import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { UserActions } from '../store/actions/UserActions';

// Any API calling or operations which require to be done once the user is authenticated
// i.e., calling user API for user permissions object(which can be used in whole application)
const AuthMonitor = () => {
  const dispatch = useDispatch();

  const dispatcher = {
    getUserDetails: () => dispatch(UserActions.getUserStart()),
  };

  const getUserDetails = () => dispatcher.getUserDetails();

  useEffect(() => {
    getUserDetails();
  }, []);

  return null;
};

export default AuthMonitor;
